import React, { Component } from 'react';
import { Form, Row, Col } from 'reactstrap';
import { request, request_file } from './request.js';
import Swal from 'sweetalert2'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'jquery/dist/jquery.min.js';
import './App.css';
import './fonts/css/open-iconic.css';
import 'animate.css';
import imagen from './imagenes/hombre.png';
import PrincipalAdmin from './MainAdmin.js';

class App extends Component 
{
	constructor(props)
	{
		super(props)
		this.state = {
			persona :
			{
				id : '',
				usuario : '',
				contrasenia : '',
			},
			encontrado : 0,
		}
	}

	handleInputChange=(event)=>
	{
		const target = event.target;
		const value = target.value;
		const name = target.name;

		var { persona } = this.state;

		persona[name] = value;

		this.setState({ persona : persona });
	}

	handleFormSubmit=(evt)=>
	{
		evt.preventDefault();
		var {persona, encontrado} = this.state;
		let temp = this;

		//Buscar por matricula y curp

		request.post('/login2',persona)
		.then(function(response)
		{
			if(response.status === 200)
			{
				persona = response.data;
				if(persona.id > 0)
				{
					encontrado = 2
					temp.setState({ persona : persona, encontrado : encontrado });
				}
				else
				{
					encontrado = 1;
					temp.setState({ encontrado : encontrado });
				}
			}
		})
		.catch(error => { });
	}


	render()
	{
		var { persona, encontrado }  = this.state;

		if(encontrado === 2) return <PrincipalAdmin />;

		return (
			<div>
	
				<div className="col-10 col-sm-8 col-md-5 col-lg-4 col-xl-3">
					<form className="animated fadeInRight login container-fluid bl latr gr2 text-left" onSubmit={this.handleFormSubmit}>
						<Row className="pb-4">
							<Col className="bordet"> </Col>
						</Row>
						<Row>
							<Col> <label className="xl b"> Secundaria #5</label> <label className="md b i">Administración </label> </Col>
						</Row>
						<Row>
							<Col> <label> </label> </Col>
						</Row>
						<Row>
							<Col> <label> <span className="oi" data-glyph="person" aria-hidden="true"></span> Usuario: </label> </Col>
						</Row>
						<Row className="pb-4">
							<Col> <input className="form-control f" type="text" value={persona.usuario} required name="usuario" placeholder="####" onChange={this.handleInputChange} /> </Col>
						</Row>
						<Row>
							<Col> <label> <span className="oi" data-glyph="key" aria-hidden="true"></span> Contraseña: </label> </Col>
						</Row>
						<Row className="pb-4">
							<Col> <input className="form-control f" type="password" value={persona.contrasenia} name="contrasenia" onChange={this.handleInputChange} /> </Col>
						</Row>
						<Row className="pt-2">
							<Col> <button className="btn btn-success btn-block" type="submit"> <b> Ingresar </b> &nbsp; <span className="oi" data-glyph="account-login" aria-hidden="true"> </span> </button> </Col>
						</Row>

						<Row className="pt-3">
							<Col>
								{
									encontrado === 1 ? 
									<div> <span className="oi" data-glyph="warning" aria-hidden="true"> </span> <font className="bl"> <i> No coinciden los datos </i> </font> </div> :
									<div className="negra"> . </div>
								}
							</Col>
						</Row>
						<Row className="pt-3">
							<Col className="bordeb"> </Col>
						</Row>
					</form>
				</div>
					
						
				
			</div>
		);
	}
}

export default App;